
























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import Heart from './Heart.vue'
import axios from 'axios'

@Component({
  components: {
    Heart,
  },
})
export default class ResultCard extends Vue {
  @Prop() content: any
  location: any;
  locationLoaded = false;

  @Emit('fav')
  fav(): { id: number; activ: boolean } {
    this.content.isFavorite = !this.content.isFavorite
    return { id: this.content.id, activ: this.content.isFavorite }
  }
  async mounted() {
    if (!this.content.actions || this.content.actions.length == 0) {
      this.content.actions = (
        await axios.get(
          'https://afq-t32f44ncfa-ey.a.run.app/items/result?fields=actions.*.*&filter=' +
            '{"id": {"_eq": ' +
            this.content.id +
            '}}',
        )
      ).data.data[0].actions
    }
    if (!this.location && this.content.location) {      
      this.location = (
        await axios.get(
          'https://afq-t32f44ncfa-ey.a.run.app/items/location?&filter=' +
            '{"id": {"_eq": ' +
            this.content.location +
            '}}',
        )
      ).data.data[0];
        this.locationLoaded = true;
    }
  }

  get actions() {
    return this.content.actions
      .filter((action: any) => !!action && !!action.action_id)
      .map((action: any) => {
        const a = action.action_id
        return {
          description: a.description,
          date: a.date,
          file: a.file,
          id: a.id,
          link: a.link,
          name: a.name,
          sort: a.sort,
          type: a.type,
        }
      })
  }

  @Emit('close')
  close() {
    return
  }
}
